export default {
  methods: {
    /* Table sorting */
    getOrders() {
      const orderBy = this.$route.query.orderBy && !Array.isArray(this.$route.query.orderBy) ? [ this.$route.query.orderBy ] : this.$route.query.orderBy ? this.$route.query.orderBy : [];
      return orderBy.map(filter => {
        const splitedFilter = filter.split('|');
        if (splitedFilter.length === 2) {
          return {
            key: splitedFilter[0],
            order: splitedFilter[1]
          };
        }
      });
    },
    async sortby(colIndex, isResetOnThird = false) {
      if (!this.cols[colIndex].sortable) return;
      // Loop through order direction, and change the order direction
      const order = [ 'asc', 'desc', '' ];
      const sortIdx = order.indexOf(this.cols[colIndex].sorted);
      this.cols[colIndex].sorted = sortIdx === order.length - 1 ? order[0] : order[sortIdx + 1];

      const tempFilter = `${this.cols[colIndex].key}|${this.cols[colIndex].sorted}`;
      if(this.cols[colIndex].sorted || !isResetOnThird)
        this.$router.push({ query: { ...this.$route.query, orderBy: [ tempFilter ] }}, this.getData);
      else
        this.$router.push(this.$route.path, this.getData);
    },
    ordercol(index) {
      return this.cols[index].sorted;
    },
  }
};
